import store from '@/store';

export default () => {
    return {
        allow: store.getters.is_spa_logout_allowed,
        redirect: { name: 'not-found' },
    }
};
